import { debounce } from "lodash"

import Hook from "../utils/hook"

export default Hook(`Navbar`, {
  values: { sticky: Boolean, stuck: Boolean },

  observer: null,

  mounted() {
    if (this.stickyValue) {
      // debounced per instance, so Navbar instances don't share one debounce timer
      this.intersectionCallbackDebounced = debounce(
        this.intersectionCallback.bind(this),
        100
      )

      this.observer = new IntersectionObserver(
        this.intersectionCallbackDebounced,
        {
          threshold: [1],
        }
      )

      this.observer.observe(this.el)
    }
  },

  destroyed() {
    this.observer?.disconnect()
    this.intersectionCallbackDebounced?.cancel()
  },

  intersectionCallback([e]) {
    this.stuckValue = e.intersectionRatio < 1
  },
})
